import "./workshop.scss";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { SetGallery } from "../Gallery/imageViewer";
import { Carousel } from "react-bootstrap";
import { allImages } from "../../services/images";
import { Helmet } from "react-helmet-async";
export default function Workshop() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    const workshop = [
        {
            description: "The company operates a fully integrated workshop spanning 4 acres, dedicated to the maintenance, repair, and management of its extensive fleet. This includes Trailers, Hydraulic Trailers, Cranes, Man-lifts, and Forklifts, all essential to our operations. Equipped with advanced diagnostic tools and machinery, our workshop ensures precise assessments and high-quality repairs, adhering strictly to manufacturer-recommended maintenance schedules to maximize performance and minimize downtime."
        },
        {
            description: "Our skilled workforce plays a crucial role in maintaining operational efficiency. All personnel undergo continuous hands-on training tailored to their roles, covering the latest maintenance techniques, safety protocols, and troubleshooting methods. Specialized programs provided by equipment manufacturers further enhance their expertise in operational safety and technological advancements."
        },
        {
            description: "Beyond in-house training, we invest in external skill development programs conducted by industry experts, ensuring our team stays updated with evolving trends, innovative maintenance practices, and regulatory requirements. Through a robust maintenance infrastructure and a highly trained workforce, we keep our fleet in peak condition, meeting operational demands while upholding the highest safety and quality standards."
        }
    ]
    return <div className="workshop">
        <Helmet>
            <title>Workshop - PBL Transport</title>
        </Helmet>
        <Heading lightMode={lightMode} heading="Workshop" />
        <div className="para">
            {workshop.map((item, i) => <p key={i}>{item.description}</p>)}
        </div>
        <div className="images">
            <Carousel controls={true} indicators={true}>
                {
                    allImages.Workshop.map((item, i) => <Carousel.Item key={i} interval={2000}>
                        <img src={item.image} alt="logo" />
                    </Carousel.Item>)
                }

            </Carousel>
        </div>
    </div>
}